import React from "react";
import CatalogSearch from "./CatalogSearch";
import { ReactComponent as FilterSvg } from "../../../assets/img/filtro.svg";
import CustomButton from "../shared/CustomButton";
import { CaretDown, CaretDownSM, CaretUp, Slider02 } from "../normalizer";
import CatalogOrderOptions from "./CatalogOrderOptions";

const CatalogSimpleHeader = (props) => {
  const {
    campaign, 
    selectedOrder, 
    onOrderChange,
    orderOptions,
    onProductTextSearch,
    searching,
    onSearchOpen,
    filtering,
    onFilterShow,
    onFilterHide,
  } = props;

  return (
    <div className="catalog-header">
      <div className="catalog-header-title">
        <h4 className="catalog-header-title-content">Prémios</h4>
      </div>
      <div className="catalog-header-container">
        <CatalogOrderOptions
          campaign={campaign}
          selectedOrder={selectedOrder}
          onOrderChange={onOrderChange}
          orderOptions={orderOptions}
        />
        <CatalogSearch
          searching={searching}
          onProductTextSearch={onProductTextSearch}
          onSearchOpen={onSearchOpen}
        />
        <CustomButton
          className="catalog-header-filter-button"
          link
          large
          tight
          onClick={filtering ? onFilterHide : onFilterShow}
        >
          <Slider02 />
          {filtering ? "Ocultar filtros" : "Filtrar"}
          {filtering ? <CaretUp /> : <CaretDown />}
        </CustomButton>
      </div>
    </div>
  );
};
export default CatalogSimpleHeader;
